const countries: any = {
  AC: { code: "247", label: "Ascension Island" },
  AD: { code: "376", label: "Andorra" },
  AE: { code: "971", label: "United Arab Emirates" },
  AF: { code: "93", label: "Afghanistan" },
  AG: { code: "1", label: "Antigua And Barbuda" },
  AI: { code: "1", label: "Anguilla" },
  AL: { code: "355", label: "Albania" },
  AM: { code: "374", label: "Armenia" },
  AO: { code: "244", label: "Angola" },
  AR: { code: "54", label: "Argentina" },
  AS: { code: "1", label: "American Samoa" },
  AT: { code: "43", label: "Austria" },
  AU: { code: "61", label: "Australia" },
  AW: { code: "297", label: "Aruba" },
  AX: { code: "358", label: "Aland Islands" },
  AZ: { code: "994", label: "Azerbaijan" },
  BA: { code: "387", label: "Bosnia And Herzegovina" },
  BB: { code: "1", label: "Barbados" },
  BD: { code: "880", label: "Bangladesh" },
  BE: { code: "32", label: "Belgium" },
  BF: { code: "226", label: "Burkina Faso" },
  BG: { code: "359", label: "Bulgaria" },
  BH: { code: "973", label: "Bahrain" },
  BI: { code: "257", label: "Burundi" },
  BJ: { code: "229", label: "Benin" },
  BL: { code: "590", label: "Saint Barthelemy" },
  BM: { code: "1", label: "Bermuda" },
  BN: { code: "673", label: "Brunei Darussalam" },
  BO: { code: "591", label: "Bolivia" },
  BQ: { code: "599", label: "Bonaire, Sint Eustatius and Saba" },
  BR: { code: "55", label: "Brazil" },
  BS: { code: "1", label: "Bahamas" },
  BT: { code: "975", label: "Bhutan" },
  BW: { code: "267", label: "Botswana" },
  BY: { code: "375", label: "Belarus" },
  BZ: { code: "501", label: "Belize" },
  CA: { code: "1", label: "Canada" },
  CC: { code: "61", label: "Cocos (Keeling) Islands" },
  CD: { code: "243", label: "Congo, Democratic Republic" },
  CF: { code: "236", label: "Central African Republic" },
  CG: { code: "242", label: "Congo" },
  CH: { code: "41", label: "Switzerland" },
  CI: { code: "225", label: "Cote D'Ivoire" },
  CK: { code: "682", label: "Cook Islands" },
  CL: { code: "56", label: "Chile" },
  CM: { code: "237", label: "Cameroon" },
  CN: { code: "86", label: "China" },
  CO: { code: "57", label: "Colombia" },
  CR: { code: "506", label: "Costa Rica" },
  CU: { code: "53", label: "Cuba" },
  CV: { code: "238", label: "Cape Verde" },
  CW: { code: "599", label: "Curacao" },
  CX: { code: "61", label: "Christmas Island" },
  CY: { code: "357", label: "Cyprus" },
  CZ: { code: "420", label: "Czech Republic" },
  DE: { code: "49", label: "Germany" },
  DJ: { code: "253", label: "Djibouti" },
  DK: { code: "45", label: "Denmark" },
  DM: { code: "1", label: "Dominica" },
  DO: { code: "1", label: "Dominican Republic" },
  DZ: { code: "213", label: "Algeria" },
  EC: { code: "593", label: "Ecuador" },
  EE: { code: "372", label: "Estonia" },
  EG: { code: "20", label: "Egypt" },
  EH: { code: "212", label: "Western Sahara" },
  ER: { code: "291", label: "Eritrea" },
  ES: { code: "34", label: "Spain" },
  ET: { code: "251", label: "Ethiopia" },
  FI: { code: "358", label: "Finland" },
  FJ: { code: "679", label: "Fiji" },
  FK: { code: "500", label: "Falkland Islands (Malvinas)" },
  FM: { code: "691", label: "Micronesia, Federated States Of" },
  FO: { code: "298", label: "Faroe Islands" },
  FR: { code: "33", label: "France" },
  GA: { code: "241", label: "Gabon" },
  GB: { code: "44", label: "United Kingdom" },
  GD: { code: "1", label: "Grenada" },
  GE: { code: "995", label: "Georgia" },
  GF: { code: "594", label: "French Guiana" },
  GG: { code: "44", label: "Guernsey" },
  GH: { code: "233", label: "Ghana" },
  GI: { code: "350", label: "Gibraltar" },
  GL: { code: "299", label: "Greenland" },
  GM: { code: "220", label: "Gambia" },
  GN: { code: "224", label: "Guinea" },
  GP: { code: "590", label: "Guadeloupe" },
  GQ: { code: "240", label: "Equatorial Guinea" },
  GR: { code: "30", label: "Greece" },
  GT: { code: "502", label: "Guatemala" },
  GU: { code: "1", label: "Guam" },
  GW: { code: "245", label: "Guinea-Bissau" },
  GY: { code: "592", label: "Guyana" },
  HK: { code: "852", label: "Hong Kong" },
  HN: { code: "504", label: "Honduras" },
  HR: { code: "385", label: "Croatia" },
  HT: { code: "509", label: "Haiti" },
  HU: { code: "36", label: "Hungary" },
  ID: { code: "62", label: "Indonesia" },
  IE: { code: "353", label: "Ireland" },
  IL: { code: "972", label: "Israel" },
  IM: { code: "44", label: "Isle Of Man" },
  IN: { code: "91", label: "India" },
  IO: { code: "246", label: "British Indian Ocean Territory" },
  IQ: { code: "964", label: "Iraq" },
  IR: { code: "98", label: "Iran, Islamic Republic Of" },
  IS: { code: "354", label: "Iceland" },
  IT: { code: "39", label: "Italy" },
  JE: { code: "44", label: "Jersey" },
  JM: { code: "1", label: "Jamaica" },
  JO: { code: "962", label: "Jordan" },
  JP: { code: "81", label: "Japan" },
  KE: { code: "254", label: "Kenya" },
  KG: { code: "996", label: "Kyrgyzstan" },
  KH: { code: "855", label: "Cambodia" },
  KI: { code: "686", label: "Kiribati" },
  KM: { code: "269", label: "Comoros" },
  KN: { code: "1", label: "Saint Kitts And Nevis" },
  KP: { code: "850", label: "Korea, Democratic People's Republic Of" },
  KR: { code: "82", label: "Korea" },
  KW: { code: "965", label: "Kuwait" },
  KY: { code: "1", label: "Cayman Islands" },
  KZ: { code: "7", label: "Kazakhstan" },
  LA: { code: "856", label: "Lao People's Democratic Republic" },
  LB: { code: "961", label: "Lebanon" },
  LC: { code: "1", label: "Saint Lucia" },
  LI: { code: "423", label: "Liechtenstein" },
  LK: { code: "94", label: "Sri Lanka" },
  LR: { code: "231", label: "Liberia" },
  LS: { code: "266", label: "Lesotho" },
  LT: { code: "370", label: "Lithuania" },
  LU: { code: "352", label: "Luxembourg" },
  LV: { code: "371", label: "Latvia" },
  LY: { code: "218", label: "Libyan Arab Jamahiriya" },
  MA: { code: "212", label: "Morocco" },
  MC: { code: "377", label: "Monaco" },
  MD: { code: "373", label: "Moldova" },
  ME: { code: "382", label: "Montenegro" },
  MF: { code: "590", label: "Saint Martin" },
  MG: { code: "261", label: "Madagascar" },
  MH: { code: "692", label: "Marshall Islands" },
  MK: { code: "389", label: "Macedonia" },
  ML: { code: "223", label: "Mali" },
  MM: { code: "95", label: "Myanmar" },
  MN: { code: "976", label: "Mongolia" },
  MO: { code: "853", label: "Macao" },
  MP: { code: "1", label: "Northern Mariana Islands" },
  MQ: { code: "596", label: "Martinique" },
  MR: { code: "222", label: "Mauritania" },
  MS: { code: "1", label: "Montserrat" },
  MT: { code: "356", label: "Malta" },
  MU: { code: "230", label: "Mauritius" },
  MV: { code: "960", label: "Maldives" },
  MW: { code: "265", label: "Malawi" },
  MX: { code: "52", label: "Mexico" },
  MY: { code: "60", label: "Malaysia" },
  MZ: { code: "258", label: "Mozambique" },
  NA: { code: "264", label: "Namibia" },
  NC: { code: "687", label: "New Caledonia" },
  NE: { code: "227", label: "Niger" },
  NF: { code: "672", label: "Norfolk Island" },
  NG: { code: "234", label: "Nigeria" },
  NI: { code: "505", label: "Nicaragua" },
  NL: { code: "31", label: "Netherlands" },
  NO: { code: "47", label: "Norway" },
  NP: { code: "977", label: "Nepal" },
  NR: { code: "674", label: "Nauru" },
  NU: { code: "683", label: "Niue" },
  NZ: { code: "64", label: "New Zealand" },
  OM: { code: "968", label: "Oman" },
  PA: { code: "507", label: "Panama" },
  PE: { code: "51", label: "Peru" },
  PF: { code: "689", label: "French Polynesia" },
  PG: { code: "675", label: "Papua New Guinea" },
  PH: { code: "63", label: "Philippines" },
  PK: { code: "92", label: "Pakistan" },
  PL: { code: "48", label: "Poland" },
  PM: { code: "508", label: "Saint Pierre And Miquelon" },
  PR: { code: "1", label: "Puerto Rico" },
  PS: { code: "970", label: "Palestinian Territory, Occupied" },
  PT: { code: "351", label: "Portugal" },
  PW: { code: "680", label: "Palau" },
  PY: { code: "595", label: "Paraguay" },
  QA: { code: "974", label: "Qatar" },
  RE: { code: "262", label: "Reunion" },
  RO: { code: "40", label: "Romania" },
  RS: { code: "381", label: "Serbia" },
  RU: { code: "7", label: "Russian Federation" },
  RW: { code: "250", label: "Rwanda" },
  SA: { code: "966", label: "Saudi Arabia" },
  SB: { code: "677", label: "Solomon Islands" },
  SC: { code: "248", label: "Seychelles" },
  SD: { code: "249", label: "Sudan" },
  SE: { code: "46", label: "Sweden" },
  SG: { code: "65", label: "Singapore" },
  SH: { code: "290", label: "Saint Helena" },
  SI: { code: "386", label: "Slovenia" },
  SJ: { code: "47", label: "Svalbard And Jan Mayen" },
  SK: { code: "421", label: "Slovakia" },
  SL: { code: "232", label: "Sierra Leone" },
  SM: { code: "378", label: "San Marino" },
  SN: { code: "221", label: "Senegal" },
  SO: { code: "252", label: "Somalia" },
  SR: { code: "597", label: "Suriname" },
  SS: { code: "211", label: "South Sudan" },
  ST: { code: "239", label: "Sao Tome And Principe" },
  SV: { code: "503", label: "El Salvador" },
  SX: { code: "1", label: "Sint Maarten" },
  SY: { code: "963", label: "Syrian Arab Republic" },
  SZ: { code: "268", label: "Swaziland" },
  TA: { code: "290", label: "Tristan da Cunha" },
  TC: { code: "1", label: "Turks And Caicos Islands" },
  TD: { code: "235", label: "Chad" },
  TG: { code: "228", label: "Togo" },
  TH: { code: "66", label: "Thailand" },
  TJ: { code: "992", label: "Tajikistan" },
  TK: { code: "690", label: "Tokelau" },
  TL: { code: "670", label: "Timor-Leste" },
  TM: { code: "993", label: "Turkmenistan" },
  TN: { code: "216", label: "Tunisia" },
  TO: { code: "676", label: "Tonga" },
  TR: { code: "90", label: "Turkey" },
  TT: { code: "1", label: "Trinidad And Tobago" },
  TV: { code: "688", label: "Tuvalu" },
  TW: { code: "886", label: "Taiwan" },
  TZ: { code: "255", label: "Tanzania" },
  UA: { code: "380", label: "Ukraine" },
  UG: { code: "256", label: "Uganda" },
  US: { code: "1", label: "United States" },
  UY: { code: "598", label: "Uruguay" },
  UZ: { code: "998", label: "Uzbekistan" },
  VA: { code: "39", label: "Holy See (Vatican City State)" },
  VC: { code: "1", label: "Saint Vincent And Grenadines" },
  VE: { code: "58", label: "Venezuela" },
  VG: { code: "1", label: "Virgin Islands, British" },
  VI: { code: "1", label: "Virgin Islands, U.S." },
  VN: { code: "84", label: "Viet Nam" },
  VU: { code: "678", label: "Vanuatu" },
  WF: { code: "681", label: "Wallis And Futuna" },
  WS: { code: "685", label: "Samoa" },
  XK: { code: "383", label: "Kosovo" },
  YE: { code: "967", label: "Yemen" },
  YT: { code: "262", label: "Mayotte" },
  ZA: { code: "27", label: "South Africa" },
  ZM: { code: "260", label: "Zambia" },
  ZW: { code: "263", label: "Zimbabwe" },
};

export default countries;